<template>
	<div class="card card-item mb-4" :class="{'disabled': isRundownDisabled, 'opacity-04': isRundownDisabled}">
		<div class="card-body">
			<div class="card-top d-flex justify-content-between">
				<div class="text-lg pointer" @click="openRundown()">
					{{ item && item.name ? item.name : '' }}
				</div>
				<md-menu
					class="h-fc"
					md-size="small"
					md-direction="bottom-end"
					md-align-trigger>
					<md-button
						class="btn-fluid"
						:md-ripple="false"
						md-menu-trigger>
						<i class="material-icons md-18 p-0 h-fc">more_vert</i>
					</md-button>
					<md-menu-content class="minw-200">
						<md-menu-item
							@click="openRundown()">
							{{ $t('Open') }}
						</md-menu-item>
						<md-menu-item v-if="!item.is_archived && (user && user.id === item.user_id) || isSuperAdmin"
							@click="emit('duplicate')">
							{{ $t('Duplicate') }}
						</md-menu-item>
						<md-menu-item
							@click="emit('export')">
							{{ $t('Export') }}
						</md-menu-item>
						<md-menu-item
							class="hidden"
							@click="emit('share')">
							{{ $t('Share') }}
						</md-menu-item>
						<md-menu-item
							@click="emit('archive')"
							v-if="!item.is_archived && (user && user.id === item.user_id) || isSuperAdmin">
							{{ $t('Archive') }}
						</md-menu-item>
						<md-menu-item
							@click="emit('unarchive')"
							v-if="item.is_archived && (user && user.id === item.user_id) || item.is_archived && isSuperAdmin">
							{{ $t('Unarchive') }}
						</md-menu-item>
						<md-menu-item
							v-if="user && user.id === item.user_id || isSuperAdmin"
							@click="emit('rename')">
							{{ $t('Rename') }}
						</md-menu-item>
						<md-menu-item
							v-if="user && user.id === item.user_id || isSuperAdmin"
							@click="emit('remove')">
							{{ $t('Delete') }}
						</md-menu-item>
					</md-menu-content>
				</md-menu>
			</div>
				<div class="d-flex justify-content-between">
					<!-- if own -->
					<div class="rd-info" v-if="item && item.user_id === user.id && item.collaborators && item.collaborators.length === 0"></div>
					<!-- if shared by -->
					<div class="truncate-rd-info" v-if="item && item.user_id !== user.id">
						<span class="card-info">Shared by {{item && item.user && item.user.name ? item.user.name : ''}}</span>
					</div>
					<!-- if own -->
					<div class="truncate-rd-info mr-a" v-if="(item && item.user_id === user.id) && item.collaborators && item.collaborators.length > 0">
						<span class="card-info">Shared with {{item.collaborators[0].name}}</span>
						<span class="card-info" v-if="item && item.collaborators && item.collaborators.length > 1"> , </span>
						<span class="card-info" v-if="(item && item.user_id === user.id) && item.collaborators && item.collaborators.length > 1">{{item.collaborators[1] && item.collaborators[1].name}}</span>
					</div>
					<!-- total collab -->
					<div v-tooltip.bottom-end="{ content: collaboratorList }" class="d-flex pt-1" v-if="item && item.collaborators && item.collaborators.length > 0">
						<div class="card-info">{{ item.collaborators && item.collaborators.length }}</div>
						<div class="card-info pl-1">Collaborators</div>
					</div>
				</div>
			<div class="card-divider"></div>
			<div class="card-info flex-center">
				<span>
					<span class="mr-2" v-if="itemsCount && itemsCount > 0">{{ itemsCount }} {{ $t('Assets') }}</span>
					<span class="mr-2" v-if="itemsCount && countActiveUsers > 0">|</span>
					<span v-if="countActiveUsers && countActiveUsers > 0">{{ countActiveUsers }} Active Users</span>
				</span>
				<span>{{ dateLabel }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import rundownsApi from '@/api/rundowns';
import { duplicateVar, elpisisString } from '@/lib/helper';

export default {
	name: 'RundownCard',
	props: {
		item: {
			type: Object,
		},
	},
	methods: {
		emit(type) {
			this.$emit(type, this.item);
		},
		hasProperty(obj, prop) {
			return Object.prototype.hasOwnProperty.call(obj, prop);
		},
		openRundown() {
			const callback = () => {
				this.$router.push(`/rundowns/editor/${btoa(this.item.slug)}`);
			};
			const errorCallback = () => {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown Items',
					text: 'please contact support!',
				});
			};
			let currentActiveUsers = duplicateVar(this.activeUsers);
			const item = {
				id: this.user.id,
				name: this.user.name,
			};
			if (currentActiveUsers && currentActiveUsers.length >= 1) {
				const index = currentActiveUsers.findIndex(({ id }) => id === this.user.id);
				if (index === -1) currentActiveUsers.push(item);
				else this.$set(currentActiveUsers, index, item);
			} else {
				currentActiveUsers = [item];
			}
			const params = {
				active_users: JSON.stringify(currentActiveUsers),
			};
			rundownsApi.update(this.item.id, params, callback, errorCallback);
		},
		showModalName(name) {
			return elpisisString(name);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isSuperAdmin: 'isSuperAdmin',
		}),
		dateLabel() {
			return dayjs(this.item.created_at).format('DD/MM/YYYY');
		},
		itemsCount() {
			const metaCount = this.item.__meta__
				&& this.item.__meta__.rundownItems_count
				? this.item.__meta__.rundownItems_count : 0;
			return metaCount;
		},
		activeUsers() {
			const parsedActiveUser = this.item
			&& typeof this.item.active_users === 'string'
			&& this.item.active_users !== '' ? this.item.active_users : null;
			return JSON.parse(parsedActiveUser);
		},
		countActiveUsers() {
			const countActiveUsers = this.activeUsers && this.activeUsers.length > 0 ? this.activeUsers.length : 0;
			return countActiveUsers;
		},
		collaboratorList() {
			const collabResult = [];
			const collab = this.item && this.item.collaborators ? this.item.collaborators : '';
			for (let index = 0; index < collab.length; index++) {
				const element = collab[index].name;
				collabResult.push(` ${element}`);
			}
			return collabResult;
		},
		isRundownDisabled() {
			const disabled = this.item && this.item.is_disabled ? this.item.is_disabled : '';
			return disabled;
		},
	},
};
</script>
